import { TrailerPool } from "../../TrailerPool";
import { CityState, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatchSelectTrailer extends Layout {
    citystateCurrentLocation: CityState;
    citystatePreviousLocation: CityState;
    labelCurrentLocationAddress2: Label;
    labelCurrentLocationAddress: Label;
    labelDispatchWarning: Label;
    labelPreviousLocationAddress2: Label;
    labelPreviousLocationAddress: Label;
    labelSelectTrailer: Label;
    layoutTrailerPoolCurrent: TrailerPool;
    layoutTrailerPoolPrevious: TrailerPool;
    panelControls: Panel;
    panelCurrentLocation: Panel;
    panelPreviousLocation: Panel;
    switchLocation: Switch;
    textboxCurrentLocation: Textbox;
    textboxPreviousLocation: Textbox;
}
